function openCartDrawer() {
  document.querySelector(".cart_drawer_custom").classList.add("open");
  document.body.classList.add("cart-drawer-open");
  addCartDrawerListeners();
}

function closeCartDrawer() {
  document.querySelector(".cart_drawer_custom").classList.remove("open");
  document.body.classList.remove("cart-drawer-open");
}

document
  .querySelectorAll(
    "#close_cart_drawer, .cart_drawer_custom, .keep_shopping_btn"
  )
  .forEach((el) => {
    el.addEventListener("click", () => {
      console.log("closing drawer");
      closeCartDrawer();
    });
  });

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

function updateCartItemCounts(count) {
  document.querySelectorAll(".card_drawer_count_total").forEach((el) => {
    el.textContent = count;
  });
  document.querySelectorAll(".cart-link__count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart_drawer_custom");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart_drawer_custom").innerHTML;

  document.querySelector(".cart_drawer_custom").innerHTML = newBox;

  addCartDrawerListeners();

  initializeSlickSlider();

  updateSlickCount();
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async (e) => {
        e.preventDefault();

        const rootItem = button.closest(".cart-item");
        const key = rootItem.getAttribute("data-line-item-key");
        const quantityInput = rootItem.querySelector(
          ".cart-drawer-quantity-selector input"
        );
        let currentQuantity = Number(quantityInput.value);
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        if (newQuantity < 1) return; // Prevent quantity below 1

        try {
          const cartRes = await fetch("/cart.js");
          const cart = await cartRes.json();
          const cartItem = cart.items.find((item) => item.key === key);

          if (!cartItem) {
            console.error("Error: Product not found in cart.");
            return;
          }

          const productRes = await fetch(`/products/${cartItem.handle}.json`);
          const productData = await productRes.json();
          let productVariant = productData.product.variants.find(
            (variant) => variant.id === cartItem.id
          );

          if (!productVariant) {
            productVariant =
              productData.product.variants.length === 1
                ? productData.product.variants[0]
                : null;
          }

          if (!productVariant) {
            console.error("Error: Product variant not found!");
            return;
          }

          const availableStock = productVariant.inventory_quantity;
          const continueSelling =
            productVariant.inventory_policy === "continue";

          let errorMessageElement = rootItem.querySelector(
            ".cart-error-message"
          );
          if (!errorMessageElement) {
            errorMessageElement = document.createElement("div");
            errorMessageElement.classList.add("cart-error-message", "drawer");
            errorMessageElement.style.color = "red";
            errorMessageElement.style.marginTop = "5px";
            errorMessageElement.style.fontSize = "14px";
            errorMessageElement.style.fontWeight = "bold";
            quantityInput.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
          }

          if (newQuantity > availableStock && !continueSelling) {
            errorMessageElement.textContent = `You cannot add more. Only ${availableStock} item(s) available.`;
            setTimeout(() => errorMessageElement.remove(), 2000);
            return;
          } else {
            errorMessageElement.textContent = ""; // Clear error message
          }

          const res = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: key,
              quantity: newQuantity,
            }),
          });

          if (!res.ok) {
            const errorData = await res.json();
            // console.error("Cart update error:", errorData);
            errorMessageElement.textContent = errorData.message;
            setTimeout(() => errorMessageElement.remove(), 2000);
            return;
          }

          const updatedCart = await res.json();
          updateCartItemCounts(updatedCart.item_count);
          await updateCartDrawer();
        } catch (error) {
          console.error("Error updating cart:", error);
        }
      });
    });

  // Remove product from cart
  document.querySelectorAll(".remove_btn").forEach((button) => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();

      const rootItem = button.closest(".cart-item");
      const key = rootItem.getAttribute("data-line-item-key");

      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });

        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();
      } catch (error) {
        console.error("Error removing item from cart:", error);
      }
    });
  });

  let Drawer = document.querySelector(".cart_drawer_custom_wrapper");
  if (Drawer) {
    Drawer.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  }

  document
    .querySelectorAll(
      "#close_cart_drawer, .cart_drawer_custom, .keep_shopping_btn"
    )
    .forEach((el) => {
      el.addEventListener("click", () => closeCartDrawer());
    });
}

addCartDrawerListeners();

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    const variantId = formData.get("id"); // Get variant ID
    const requestedQuantity = Number(formData.get("quantity") || 1); // Get requested quantity
    const addToCartButton = form.querySelector('[type="submit"]'); // Add to Cart button
    const availQty = addToCartButton.getAttribute("data-quantity");
    const policy = addToCartButton.getAttribute("data-policy");
    let errorMessageElement = form.querySelector(".cart-error-message");

    // If error message element doesn't exist, create it
    if (!errorMessageElement) {
      errorMessageElement = document.createElement("div");
      errorMessageElement.classList.add("cart-error-message");
      errorMessageElement.style.color = "red";
      errorMessageElement.style.marginTop = "5px";
      errorMessageElement.style.fontSize = "14px";
      errorMessageElement.style.fontWeight = "bold";
      addToCartButton.insertAdjacentElement("beforebegin", errorMessageElement);
    }

    setTimeout(function () {
      errorMessageElement.remove();
    }, 2000);

    if (!variantId) {
      errorMessageElement.textContent = "Error: Product variant ID is missing!";
      return;
    }

    try {
      // Fetch current cart data
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();

      // Get current quantity in cart for this variant
      let currentCartQuantity = 0;
      const cartItem = cart.items.find((item) => item.id == variantId);
      if (cartItem) {
        currentCartQuantity = cartItem.quantity;
      }

      console.log("st", currentCartQuantity);

      // Fetch available stock (Mock method - replace with actual inventory check)
      const availableStock = availQty; // Replace this with actual stock check if needed

      // Check if requested quantity exceeds available stock
      if (policy == "deny") {
        if (currentCartQuantity + requestedQuantity > availableStock) {
          errorMessageElement.textContent = `You cannot add more. Only ${availableStock} item(s) available.`;
          return;
        }
      }

      // If stock is available, clear error message
      errorMessageElement.textContent = "";

      // Add product to cart
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: requestedQuantity }),
      });

      // Update cart UI
      const updatedCartRes = await fetch("/cart.js");
      const updatedCart = await updatedCartRes.json();
      updateCartItemCounts(updatedCart.item_count);
      await updateCartDrawer();
      openCartDrawer();
    } catch (error) {
      console.error("Error adding to cart:", error);
      errorMessageElement.textContent =
        "There was an issue adding the product to the cart. Please try again.";
    }
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

function initializeSlickSlider() {
  if ($(".you_may_also_product_div_slider").hasClass("slick-initialized")) {
    $(".you_may_also_product_div_slider").slick("unslick"); // Destroy previous instance
  }

  $(".you_may_also_product_div_slider").slick({
    dots: true,
    infinite: false,
    touchThreshold: 100,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    adaptiveHeight: true,
    cssEase: "linear",
    prevArrow: $(".prev_buttion"),
    nextArrow: $(".next_buttion"),
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

initializeSlickSlider();

function updateSlickCount() {
  $(".you_may_also_product_div_slider").on(
    "init afterChange",
    function (event, slick, currentSlide) {
      if (typeof currentSlide === "undefined") {
        currentSlide = 0; // When Slick initializes, set to 0
      }

      let slidesShown = slick.options.slidesToScroll; // Number of slides moved per action
      let currentIndex = currentSlide + slidesShown; // Adjust index

      // Prevent exceeding total slides count
      if (currentIndex > slick.slideCount) {
        currentIndex = slick.slideCount;
      }

      $(".navigation_number span").text(currentIndex);
    }
  );
}

updateSlickCount();

